package twist.mena.sports.admin.screens

import androidx.compose.runtime.*
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import twist.mena.sports.admin.api.AdminApiClient
import twist.mena.sports.admin.components.Column
import twist.mena.sports.admin.components.DataTable
import twist.mena.sports.admin.components.SearchBar
import twist.mena.sports.admin.state.UiState
import twist.mena.sports.admin.theme.*
import twist.mena.sports.shared.dto.admin.AdminPlayerResponse
import twist.mena.sports.shared.dto.admin.OffsetPage

@Composable
fun PlayersScreen(apiClient: AdminApiClient) {
    val colors = AppTheme.colors
    var state by remember { mutableStateOf<UiState<OffsetPage<AdminPlayerResponse>>>(UiState.Loading) }
    var search by remember { mutableStateOf("") }
    var offset by remember { mutableStateOf(0) }
    val scope = rememberCoroutineScope()

    LaunchedEffect(search, offset) {
        state = UiState.Loading
        scope.launch {
            try {
                val page = apiClient.getPlayers(search.ifBlank { null }, offset)
                state = UiState.Success(page)
            } catch (e: Exception) {
                state = UiState.Error("Failed to load players")
            }
        }
    }

    SearchBar(placeholderText = "Search players...") { query ->
        search = query
        offset = 0
    }

    when (val s = state) {
        is UiState.Loading -> P({ style { color(Color(colors.textMuted)) } }) { Text("Loading...") }
        is UiState.Error -> P({ style { color(Color(colors.danger)) } }) { Text(s.message) }
        is UiState.Success -> {
            val page = s.data
            val columns = listOf(
                Column<AdminPlayerResponse>("Name (EN)") { player ->
                    Text(player.nameEn)
                },
                Column("Name (AR)") { player ->
                    Text(player.nameAr ?: "\u2014")
                },
                Column("Position") { player ->
                    Text(player.position ?: "\u2014")
                },
                Column("Nationality") { player ->
                    Text(player.nationality ?: "\u2014")
                },
                Column("DOB") { player ->
                    Text(player.dateOfBirth ?: "\u2014")
                },
                Column("Vendor ID") { player ->
                    Span({ style { fontFamily("monospace"); fontSize(Typography.sm) } }) {
                        Text(player.vendorPlayerId)
                    }
                }
            )

            DataTable(
                columns = columns,
                rows = page.data,
                total = page.total,
                offset = page.offset,
                limit = page.limit,
                onPageChange = { newOffset -> offset = newOffset }
            )
        }
    }
}
